export function refreshLearning() {
  if (typeof window !== "undefined")
    window.dispatchEvent(new Event("chess-activity"));
}
